module.exports = __webpack_public_path__ + "img/Mask Group_2@2x.bb989fa7.png";